angular
	.module 'App.Repository', []
	.factory 'BaseRepository',
	[
		'$http',
		'CredentialsManager',
		'API_ENDPOINT',
		'UserRestrictionService',
		'$q',
		'FormDataObject',
		'ToastService',
		(
			$http,
			CredentialsManager,
			API_ENDPOINT,
			UserRestrictionService,
			$q,
			FormDataObject,
			ToastService,
		) ->
			class BaseRepository
				@isLockdown: false

				pageSize: 25
				bigPageSize: 400

				resolve: (value = null) ->
					return $q.resolve(value)

				reject: (value = null) ->
					return $q.reject(value)

				all: (promises) ->
					return $q.all(promises)

				lock: ->
					BaseRepository.isLockdown = true

				getPageSize: ->
					return @pageSize

				setPageSize: (value) ->
					@pageSize = value

				getEntity: (id, query = null, emptyValue = {}) ->
					if _.isEmpty(id)
						return @resolve(emptyValue)

					return @findById(id, query).then (response) -> return response.data

				getEntities: (query = null) ->
					return @findByQuery(query).then (response) -> return response.data

				countEntities: (query = null) ->
					return @count query
						.then (response) ->
							return parseInt(response.data.count)
						.catch ->
							return 0

				getEntitiesWithCount: (query = null) ->
					return @all {count: @countEntities(query), data: @getEntities(query)}

				list: ->
					return @findByQuery()

				find: (url, query = null, resource = null) ->
					return @findByQuery(query, '/' + url, resource)

				findById: (id, query = null, resource = null) ->
					return @request('GET', @getUrl('/' + id, resource), undefined, @createConfig(query))

				findByQuery: (query = null, url = '', resource = null) ->
					return @request('GET', @getUrl(url, resource), undefined, @createConfig(query))

				delete: (id) ->
					return @request('DELETE', @getUrl('/' + id), undefined, @createConfig())

				uploadFile: (url, requestBody, method = 'POST') ->
					config = @getConfigForRequestWithAttachment()

					return @request(method, @getUrl('/' + url), requestBody, config)

				saveWithAttachment: (model, isNew = false) ->
					if !model.id || isNew
						method = 'POST'
						url = ''
					else
						method = 'PUT'
						url = model.id

					return @uploadFile(url, model, method)

				getConfigForRequestWithAttachment: ->
					config =
						params: @createConfig()['params']
						headers:
							'Content-Type': undefined
						transformRequest: FormDataObject

					@applyHeaders(config)

					return config

				save: (model, isNew = false, usePatch = false, id = null) ->
					id ?= model.id

					if !id || isNew
						return @post '', model

					if usePatch
						return @patch id, model

					return @put id, model

				fetch: (url, query = null, resource = null) ->
					return @request('GET', @getUrl(url, resource), undefined, @createConfig(query))

				put: (url, data = [], query = null, resource = null) ->
					return @request('PUT', @getUrl('/' + url, resource), data, @createConfig(query))

				post: (url, data = [], query = null, resource = null) ->
					return @request('POST', @getUrl('/' + url, resource), data, @createConfig(query))

				patch: (url, data = [], query = null, resource = null) ->
					return @request('PATCH', @getUrl('/' + url, resource), data, @createConfig(query))

				count: (query = null, resource = null) ->
					resource ?= @constructor.resource

					return @request('GET', API_ENDPOINT + "/count" + resource, undefined, @createConfig(query))

				getUrl: (url = '', resource = null) ->
					resource ?= @constructor.resource

					if url == '/'
						url = ''

					return API_ENDPOINT + resource + url

				request: (method, url, data = [], configuration = {}) ->
					if BaseRepository.isLockdown
						message = 'System in lockdown - request rejected'

						console.error(message, method, url)

						return @reject({data: {error: message}})

					defaultConfig = {
						method: method
						url: url
						data: data
					}
					config = angular.extend {}, defaultConfig, configuration

					return $http(config)
						.catch (response) =>
							ToastService.showErrors response

							response.is_handled = true

							return @reject response

				toString: (query, url = '', resource = null) ->
					resource ?= @constructor.resource
					baseUrl = @getUrl(encodeURI(url), resource)
					parameters = []
					configurations = @createConfig(query)

					if @constructor.isRestricted
						CredentialsManager.injectResourceToken configurations

					angular.forEach(configurations.params, (value, key) ->
						parameters.push(encodeURI(key + '=' + value))
					)

					if parameters.length
						if url.indexOf('?') == -1
							baseUrl += '?'
						else
							baseUrl += '&'

						baseUrl += parameters.join('&')

					return baseUrl

				createConfig: (query = null, withToken = @constructor.isRestricted) ->
					config = {
						params: {},
						interval: {},
						headers: {}
					}

					@applyHeaders(config, withToken)

					if _.isEmpty query
						query = @getQuery()

					query = @applyUserRestrictions(query)

					if query.criterias.length > 0
						config.params.filter = query.criteriaToJSON()

					if angular.isDefined query.pagination
						config.params.pagination = JSON.stringify query.pagination

					if angular.isDefined(query.sortByValues) && query.sortByValues.length > 0
						config.params.sort = JSON.stringify query.sortByValues

					if query.withoutRelations
						config.params.with = "[]"
					else if !_.isEmpty query.withValues
						config.params.with = JSON.stringify query.withValues

					if !angular.equals(query.parameters, {})
						config.params = angular.extend(config.params, query.parameters)

					return config

				applyHeaders: (config = {}, withToken = @constructor.isRestricted) ->
					if withToken
						CredentialsManager.injectAccessToken config

				getSearchQuery: ->
					return @getQuery()

				getQuery: ->
					return new Query()

				###
				@deprecated Use getQuery
				###
				createQuery: ->
					return @getQuery()

				applyUserRestrictions: (query) ->
					return UserRestrictionService.apply(@constructor.name, query)

				###
					Returns selected and existing external attributes as a an object
					attributesToMap => [{attributeName: defaultValue}, attributeName, ...]
				###
				getAttributesAsObject: (modelAttributes, attributesToMap) ->
					if _.isEmpty(modelAttributes)
						return {}

					objectAttributes = {}

					for newAttribute in attributesToMap
						if newAttribute?.length && angular.isObject(newAttribute)
							objectKeys = Object.keys(newAttribute)

							if angular.isDefined(objectKeys[0])
								objectAttributes[objectKeys[0]] = newAttribute[objectKeys[0]]
							else
								break

						else if newAttribute?.length && angular.isString(newAttribute)
							objectAttributes[newAttribute] = null

						# Searches model attributes
						for attribute in modelAttributes
							if newAttribute of attribute
								objectAttributes[newAttribute] = attribute[newAttribute]
								break

					return objectAttributes
	]
